var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-box"},[_c('div',[_c('p',{staticClass:"nickname"},[_vm._v("欢迎登录「"+_vm._s(_vm.userInfo.user_name)+"」")]),_c('p',[_vm._v("媒资库后台")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }